import { REDUCER_NAME } from './const'
import { selectOwnState as selectParentState } from '../selector'

export const selectOwnState = (state) => {
    return selectParentState(state)[REDUCER_NAME]
}

export const selectStore = state => {
    return selectOwnState(state).store
}

export const selectRedirect = state => {
    return selectOwnState(state).redirect
}

export const selectIsFetching = state => {
    return selectOwnState(state).fetching
}

export const selectValidationMessageList = state => {
    return selectOwnState(state).validationMessageList
}

export const selectHasChanged = state => {
    return selectOwnState(state).hasChanged
}




// WEBPACK FOOTER //
// ./src/modules/store/state/detail/selector.js